// client/src/shared/configSchema.js
/**
 * Validates and normalizes the runtime config assembled by ConfigProvider.
 * We fail fast on critical keys needed by Reservations & Month.
 */
function parseJSON(name, value, errors) {
  if (!value) return undefined;
  if (typeof value !== "string") return value;
  try { return JSON.parse(value); }
  catch { errors.push({ key: name, message: `Must be valid JSON` }); return undefined; }
}

export function validateRuntimeConfig(cfg = {}) {
  const errors = [];
  const req = (k, msg) => {
    const v = cfg[k];
    if (v === undefined || v === null || String(v).trim() === "") {
      errors.push({ key: k, message: msg || "Required" });
    }
  };

  // Critical
  req("locationId", "Provide via URL (?locationId=...) or set as a Custom Value.");
  if (!cfg.groupId && !cfg.calendarId) {
    errors.push({ key: "calendarId/groupId", message: "Provide at least one. Group ID enables Month view aggregation." });
  }
  req("pipelineId", "Required to move Opportunities between stages.");

  // JSON fields
  const mealTimes = parseJSON("mealTimes", cfg.mealTimes, errors);
  const oppCFMap = parseJSON("oppCFMap", cfg.oppCFMap, errors);

  if (!mealTimes || !mealTimes.breakfast || !mealTimes.lunch || !mealTimes.dinner) {
    errors.push({ key: "mealTimes", message: "Expect { breakfast:{start,end}, lunch:{start,end}, dinner:{start,end} } (24h)." });
  }

  const avg = Number(cfg.avgCover);
  if (!Number.isFinite(avg) || avg <= 0) {
    errors.push({ key: "avgCover", message: "Must be a positive number." });
  }

  // Helpful (not hard-fail for canary)
  if (!cfg.featureFlags) {
    errors.push({ key: "featureFlags", message: "Empty; enable 'reservations,month,settings,realtime' for launch." });
  }
  if (!oppCFMap || typeof oppCFMap !== "object") {
    errors.push({ key: "oppCFMap", message: "Map logical keys to Opportunity CF IDs. Example: { \"party_size\": \"AbC123\" }" });
  }

  return {
    ok: errors.length === 0,
    errors,
    normalized: {
      ...cfg,
      mealTimes: mealTimes || {},
      oppCFMap: oppCFMap || {},
      avgCover: Number.isFinite(avg) ? avg : 0,
    },
  };
}
